export default __webpack_public_path__ + "static/media/Comuni logo white.c5d7b92b.png";